import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface Props {
    id: ModelId;
    hash: string;
}

const initialState: Props = {
    id: 0,
    hash: ''
};

export const messageSentSlice = createSlice({
    name: 'messageSent',
    initialState,
    reducers: {
        set(state, action: PayloadAction<{ id: ModelId, hash: string; }>) {
            state.id = action.payload.id;
            state.hash = action.payload.hash;
        }
    }
});
